import { filter, reduce } from 'lodash';
import {
  GET_CREDENTIALS_GROUPS_SUCCESS,
  GET_CREDENTIALS_GROUPS_FAILURE,
  GET_CREDENTIALS_GROUP_SUCCESS,
  CREATE_CREDENTIALS_GROUP_SUCCESS,
  DELETE_CREDENTIALS_GROUP_SUCCESS,
  GET_CREDENTIALS_GROUP_CREDENTIALS_SUCCESS,
  UPDATE_CREDENTIALS_GROUP_SUCCESS,
  GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_SUCCESS,
  GET_CREDENTIALS_GROUP_CREDENTIALS_FAILURE,
  GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_FAILURE,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';

const initialState = {
  byId: [],
  credentialsById: {},
  lastUpdated: null,
  error: null,
  listing: [],
};

export const credentialsGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CREDENTIALS_GROUPS_SUCCESS:
      return saveCredentialsGroups(state, action);

    case GET_CREDENTIALS_GROUPS_FAILURE:
      return removeCredentialsGroups(state, action);

    case GET_CREDENTIALS_GROUP_SUCCESS:
    case CREATE_CREDENTIALS_GROUP_SUCCESS:
      return saveCredentialsGroup(state, action);

    case DELETE_CREDENTIALS_GROUP_SUCCESS:
      return deleteCredentialsGroup(state, action);

    case GET_CREDENTIALS_GROUP_CREDENTIALS_SUCCESS:
      return saveCredentialGroupCredentialsListing(state, action);

    case GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_SUCCESS:
      return saveAllCredentialGroupCredentials(state, action);

    case GET_CREDENTIALS_GROUP_CREDENTIALS_FAILURE:
    case GET_ALL_CREDENTIALS_GROUP_CREDENTIALS_FAILURE:
      return {
        ...state,
        error: action.error,
        lastUpdated: action.receivedAt,
      };

    case UPDATE_CREDENTIALS_GROUP_SUCCESS:
      return updateCredentialsGroup(state, action);

    default:
      return state;
  }
};

function saveCredentialsGroups(state, action) {
  const { result } = action;
  const { byId } = state;
  const newById = [...byId, ...result];

  return {
    ...state,
    byId: newById,
    lastUpdated: action.receivedAt,
    error: null,
  };
}

function removeCredentialsGroups(state, action) {
  // TODO: waiting on API call to be implemented for delete
  // using update call in the meantime
  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: [],
    error: action.error,
  };
}

function saveCredentialsGroup(state, action) {
  const { result } = action;
  const { byId } = state;
  const newById = [...byId, result.id];

  return {
    ...state,
    byId: newById,
    lastUpdated: action.receivedAt,
    error: null,
  };
}

function deleteCredentialsGroup(state, action) {
  const {
    requestInfo: { id },
  } = action;
  const { byId } = state;
  const newById = filter(state.byId, (groupId) => groupId !== id);

  return {
    ...state,
    byId: newById,
    lastUpdated: action.receivedAt,
    error: null,
  };
}

function saveCredentialGroupCredentialsListing(state, action) {
  const { result } = action;

  return {
    ...state,
    listing: result,
    lastUpdated: action.receivedAt,
    error: null,
  };
}

function saveAllCredentialGroupCredentials(state, action) {
  const { result, requestInfo } = action;
  const groupId = requestInfo.id;
  const { credentialsById } = state;

  return {
    ...state,
    credentialsById: {
      ...credentialsById,
      [groupId]: result,
    },
    lastUpdated: action.receivedAt,
    error: null,
  };
}

function updateCredentialsGroup(state, action) {
  const { result, requestInfo } = action;
  const { credentialsById } = state;
  const groupId = requestInfo.id;
  const credentials = requestInfo?.info?.data_credentials;

  // if user is updating credentials data, update the credentialsById
  if (credentials) {
    return {
      ...state,
      credentialsById: {
        ...credentialsById,
        [groupId]: credentials,
      },
    };
  }

  return state;
}

export default credentialsGroupsReducer;
